<!-- Splash screen stuff -->
<!-- <div id="custom-overlay" [style.display]="splash ? 'flex' : 'none'">
    <div class="flb">
        <div class="Aligner-item Aligner-item--top"></div>
        <img src="assets/images/splash.svg?v=2">
        <div class="Aligner-item Aligner-item--bottom"></div>
    </div>
</div> -->

<!-- Login screen stuff -->
<ion-content class="background ion-text-center ion-no-padding">
    <ion-grid>
        <ion-row class="header">
            <ion-col>ShuttleNomix</ion-col>
        </ion-row>
        <ion-row class="subheader">
            <ion-col>Shuttle Automation</ion-col>
        </ion-row>
        <ion-row class="subheader">
            <ion-col>For Car Dealerships</ion-col>
        </ion-row>
    </ion-grid>

    <br />
    <form name="form" (ngSubmit)="f.form.valid && onLoginClick()" #f="ngForm" novalidate>

        @if (showLoginDiv===true) {
            <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-card class="default">
                        <ion-card-header>
                            <div data-test="title" class="title">Backend Login</div>
                            <div data-test="version" class="version">Version {{vm.version}}</div>
                        </ion-card-header>

                        <ion-card-content class="ion-no-padding">
                            <app-loginCard (userCredentialEvent)="handleUserCredentials($event)" [appSource]="backend">
                            </app-loginCard>


                            <!-- <ion-list lines="none" class="ion-no-padding">
                                <ion-item>
                                    <ion-label position="stacked">Email Address</ion-label>
                                    <ion-input type="text" [(ngModel)]="user.email" name="email" data-test="email"></ion-input>
                                </ion-item>

                                <ion-item>
                                    <ion-label position="stacked">Password</ion-label>
                                    <ion-input type="password" #password [(ngModel)]="user.password"
                                        name="password"></ion-input>

                                    <ion-buttons class="itemButtons" slot="end">
                                        <ion-button class="itemButton" color="primary" expand="full" fill="solid"
                                            id="eye" (click)="onEyeClick()">
                                            <ion-icon name="eye-sharp"></ion-icon>
                                        </ion-button>
                                    </ion-buttons>
                                </ion-item>

                                <ion-button expand="block" class="loginBtn ion-padding" #loginButton
                                    (click)="onLoginClick()">{{vm.loginText}}</ion-button>
                            </ion-list> -->
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col>
                    <a data-test="forgotPasswordLink" (click)="onToggleLoginVisibility()">Forgot Password?</a>
                </ion-col>
            </ion-row>
        </ion-grid>
}
    </form>

    <!-- Forgot Password Slide -->
    @if (showLoginDiv===false) {
  <ion-grid>
        <ion-row>
            <ion-col>
                <ion-card class="default">
                    <ion-card-header>
                        <div data-test="forgotPasswordTitle" class="title">Forgot Password</div>
                    </ion-card-header>
                    <ion-card-content class="ion-no-padding">
                        <ion-list lines="none" class="ion-no-padding">
                            <ion-item>
                                <ion-label position="stacked">Email Address</ion-label>
                                <ion-input data-test="forgotEmail" type="text" [(ngModel)]="user.email"></ion-input>
                            </ion-item>

                            <br />
                            <ion-button data-test="resetPasswordButton" expand="block" class="forgotBtn ion-padding" (click)="onResetPasswordClick()">Send Password Reset Email</ion-button>
                            <br />
                        </ion-list>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col>
                <a data-test="backToLoginLink" (click)="onToggleLoginVisibility()">Back to Login</a>
            </ion-col>
        </ion-row>
    </ion-grid>
}
</ion-content>